import React from 'react';

import API from 'utils/api';
import Logger from 'utils/logger';

import { UserFieldDropdownKind, UserFieldOption } from 'utils/api/modules/user/user.types';

import { CUSTOM_FIELD_PREFIX } from './registry';

const OPTION_KINDS: UserFieldDropdownKind[] = ['department', 'region', 'employment-type'];

export interface RuleFieldData {
  optionsByKind: Record<string, UserFieldOption[]>;
  customFieldLabels: Record<string, string>;
}

export const useRuleFieldData = (enabled = true): RuleFieldData => {
  const [optionsByKind, setOptionsByKind] = React.useState<Record<string, UserFieldOption[]>>({});
  const [customFieldLabels, setCustomFieldLabels] = React.useState<Record<string, string>>({});

  React.useEffect(() => {
    if (!enabled) {
      return undefined;
    }
    let mounted = true;

    Promise.all(OPTION_KINDS.map((kind) => API.user.listUserFieldOptions(kind, { include_inactive: true })()))
      .then((responses) => {
        if (!mounted) return;
        setOptionsByKind(Object.fromEntries(OPTION_KINDS.map((kind, index) => [kind, responses[index].data])));
      })
      .catch((error: unknown) => Logger.error('Failed to load rule dropdown options', error));

    API.user
      .loadUserFieldsGrid()()
      .then((response) => {
        if (!mounted) return;
        const labels: Record<string, string> = {};
        response.data.forEach((row) => {
          if (row.kind === 'custom') {
            labels[`${CUSTOM_FIELD_PREFIX}${row.slot}`] = row.label;
          }
        });
        setCustomFieldLabels(labels);
      })
      .catch((error: unknown) => Logger.error('Failed to load custom field labels', error));

    return () => {
      mounted = false;
    };
  }, [enabled]);

  return { optionsByKind, customFieldLabels };
};
